class VirtualTryOn extends HTMLElement {
  connectedCallback() {
    this.detailsList = Array.from(
      this.querySelectorAll('.virtual-modal__filter details')
    );

    this.detailsList.forEach((detail) => {
      const summary = detail.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', () => {
        this.detailsList.forEach((other) => {
          if (other !== detail) other.removeAttribute('open');
        });
      });
    });
  }
}

customElements.define('virtual-try-on', VirtualTryOn);